// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.syngenta-quotation .state-selector,
.syngenta-quotation .culture-selector {
  margin-top: var(--spacing-small);
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Product/QuotationModal/Syngenta.less"],"names":[],"mappings":"AAAA;;EAGI,gCAAA;AAAJ","sourcesContent":[".syngenta-quotation {\n  .state-selector,\n  .culture-selector {\n    margin-top: var(--spacing-small);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
